// extracted by mini-css-extract-plugin
module.exports = {"ltr":"editor-module__ltr___1tS8k","rtl":"editor-module__rtl___2hUT5","paragraph":"editor-module__paragraph___1NV1Z","link":"editor-module__link___3DTdj"};